<p class="modal-title">Supply Drop: Requirements</p>

<div class="requirements-list flex flex-col gap-4">
  <div class="requirement flex items-center gap-8">
    <app-checkbox
      [disabled]="true"
      class="requirement-checkbox"
      [checked]="true"
      style="filter: grayscale(1)"
    >
      <p class="requirement-description flex items-center gap-4">
        Wager 1$ in a raked game the past hour
      </p>
    </app-checkbox>
  </div>
  <div class="requirement flex items-center gap-8">
    <app-checkbox
      [disabled]="true"
      class="requirement-checkbox"
      [(checked)]="requirements().level"
      ><p class="requirement-description flex items-center gap-4">
        Level 10+ on site
      </p></app-checkbox
    >
  </div>
  <div class="requirement flex items-center gap-8">
    <app-checkbox
      [disabled]="true"
      class="requirement-checkbox"
      [(checked)]="requirements().discord"
    >
      <p class="requirement-description flex items-center gap-4">
        Join our
        <svg-icon
          class="flex items-center justify-center s-16"
          src="assets/icons/socials/discord.svg"
        ></svg-icon>
        <span class="highlight">Discord</span> server and
        <span
          class="highlight"
          (click)="$event.stopPropagation(); sessionService.authDiscord()"
          style="cursor: pointer"
        >
          verify
        </span>
        you
        <a
          class="highlight"
          style="cursor: pointer"
          (click)="$event.stopPropagation()"
          [href]="DISCORD_LINK"
          target="_blank"
        >
          joined
        </a>
      </p>
    </app-checkbox>
  </div>
</div>
